import { SOGetCertificate } from '../certificate/so-get-certificate';
import { SOGetRoleGrant } from '../role-grant/so-get-role-grant';


export class SOPostToken {

  constructor(
    public certificate: SOGetCertificate = null,
    public roleGrant: SOGetRoleGrant = null,
    public accessToken: string = null,
  ) {
  }
  static construct(params: {[key: string]: any}) {
    return new SOPostToken(
      'certificate' in params ? params.certificate : null,
      'roleGrant' in params ? params.roleGrant : null,
      'accessToken' in params ? params.accessToken : null,
    );
  }
}
